import { render, staticRenderFns } from "./CustomerEditPage.vue?vue&type=template&id=0d12d4e8&scoped=true&"
import script from "./CustomerEditPage.vue?vue&type=script&lang=js&"
export * from "./CustomerEditPage.vue?vue&type=script&lang=js&"
import style0 from "./CustomerEditPage.vue?vue&type=style&index=0&id=0d12d4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12d4e8",
  null
  
)

export default component.exports